import { Form } from "antd";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { FundsService } from "../../../../../../services/FundService/Fund.service";
import InputField from "../../../../../../shared/components/InputField";
import { useDebouncer } from "../../../../../../shared/hooks/useDebouncer";

interface OtherItemNotesProps {
  id: number;
}

const OtherItemNotes = (props: OtherItemNotesProps) => {
  const { id } = props;
  const [notes, setNotes] = useState<{ description: string }>();

  const fetchNotes = () => {
    FundsService.fetchNotes(
      "OtherItem",
      id.toString(),
      (response) => {
        setNotes(response);
      },
      () => { },
      () => { }
    );
  };

  const updateNotes = (notes) => {
    FundsService.updateNotes(
      "OtherItem",
      id.toString(),
      notes,
      () => { },
      () => { },
      () => { }
    );
  };

  useEffect(() => {
    fetchNotes();
  }, []);

  const handleUpdate = useDebouncer((description) => {
    updateNotes({ description });
  }, 1000)

  return (
    <Formik enableReinitialize initialValues={notes} onSubmit={() => { }}>
      {({ setFieldValue, values, resetForm, isValid }) => {
        return (
          <Form>
            <div className="onboarding-notes">
              <InputField
                showLabel={false}
                onChange={(event) => {
                  setFieldValue("description", event.target.value)
                  //@ts-ignore
                  handleUpdate(event.target.value)
                }}
                placeholder={"Add your notes..."}
                name="description"
                type="textarea"
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default OtherItemNotes;
